"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.takeUntil = takeUntil;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _OuterSubscriber2 = require("../OuterSubscriber");

var _subscribeToResult = require("../util/subscribeToResult");

/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
  return function (source) {
    return source.lift(new TakeUntilOperator(notifier));
  };
}

var TakeUntilOperator =
/*#__PURE__*/
function () {
  function TakeUntilOperator(notifier) {
    (0, _classCallCheck2.default)(this, TakeUntilOperator);
    this.notifier = notifier;
  }

  (0, _createClass2.default)(TakeUntilOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    }
  }]);
  return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var TakeUntilSubscriber =
/*#__PURE__*/
function (_OuterSubscriber) {
  (0, _inherits2.default)(TakeUntilSubscriber, _OuterSubscriber);

  function TakeUntilSubscriber(destination, notifier) {
    var _this;

    (0, _classCallCheck2.default)(this, TakeUntilSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TakeUntilSubscriber).call(this, destination));
    _this.notifier = notifier;

    _this.add((0, _subscribeToResult.subscribeToResult)((0, _assertThisInitialized2.default)(_this), notifier));

    return _this;
  }

  (0, _createClass2.default)(TakeUntilSubscriber, [{
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      this.complete();
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete() {// noop
    }
  }]);
  return TakeUntilSubscriber;
}(_OuterSubscriber2.OuterSubscriber);